module.exports = "https://www.gc-pro.gnp.com.mx/cee2fb9bb77388676ddb6e554f977b41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-gnp.svg
// module id = 167
// module chunks = 0